import { useState } from 'react'

import { useUnit } from 'effector-react'

import ArrowDropDownIcon from '@/assets/icons/icon-arrow-drop-down.svg'
import { Breadcrumbs } from '@/components/ui/breadcrumbs.tsx'
import { Button } from '@/components/ui/button.tsx'
import { $creatorId } from '@/models/creators.ts'
import type {
  PpvMediaSet,
  PpvTrackingCategory,
} from '@/modules/tracking/ppv/types.ts'
import { PpvMessagesStats } from '@/modules/tracking/ppv/ui/messages/PpvMessagesStats.tsx'
import { AppRoutes } from '@/utils/constants.ts'
import { classNames } from '@/utils/helpers'

interface PpvMessagesTopPageComponentsProps {
  category: PpvTrackingCategory
  mediaSet: PpvMediaSet
  showCents?: boolean
}

export const PpvMessagesTopPageComponents = (
  props: PpvMessagesTopPageComponentsProps,
) => {
  const { category, mediaSet } = props
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const handleButtonClick = () => {
    setIsExpanded(!isExpanded)
  }

  const creatorId = useUnit($creatorId) ?? ''
  const content = mediaSet.highlighted.content

  return (
    <>
      <Breadcrumbs
        breadcrumbs={[
          {
            name: `${category.name || ''} Script`,
            to: AppRoutes.Creator.ChatterTracking.Ppv.Details.asUrl(
              creatorId,
              String(category.index),
            ),
          },
          {
            name: 'Messages',
          },
        ]}
      />
      <h2 className="mt-4 text-3xl font-semibold text-title">Messages</h2>
      {content && (
        <div className="mt-2 flex items-center">
          <div className="text-sm text-text-sub">
            {content.length > 100 ? (
              <>
                <span className="mr-2">
                  {isExpanded ? content : `${content.slice(0, 100)}...`}
                </span>
                <Button
                  variant="ghost"
                  className="h-6 p-0"
                  onClick={handleButtonClick}
                >
                  Show {isExpanded ? 'less' : 'more'}
                  <ArrowDropDownIcon
                    className={classNames(
                      'fill-primary-500',
                      isExpanded && 'rotate-180',
                    )}
                  />
                </Button>
              </>
            ) : (
              content
            )}
          </div>
        </div>
      )}
      <PpvMessagesStats
        showCents={props.showCents}
        mediaSet={mediaSet}
      />
    </>
  )
}
